import { render, staticRenderFns } from "./AddManagerNewForm.vue?vue&type=template&id=28c73cb1"
import script from "./AddManagerNewForm.vue?vue&type=script&lang=ts"
export * from "./AddManagerNewForm.vue?vue&type=script&lang=ts"
import style0 from "./AddManagerNewForm.vue?vue&type=style&index=0&id=28c73cb1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports